export default __webpack_public_path__ + "static/media/27.746bd9e9.webp";